/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Button, Typography } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";

type TextButtonProps = {
  text: string;
} & ButtonProps;

export default function TextButton({text, ...rest}: TextButtonProps) {

  return (
    <Button color="primary" {...rest}>
      <Typography textTransform={"none"}>
        {text}
      </Typography>
    </Button>
  );
};
